<template>
  <v-dialog @update:returnValue="setEditItemIdPermissionsZero" v-model="dialogPermissions" persistent max-width="500px">
    <v-card>
      <v-card-text class="text-md-center">
        <v-flex xs12 sm6 md12>
          <v-select
            multiple
            label="Select Permissions"
            :items="permissionsList"
            v-model="selectedPermissions"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip>
                <span>{{ item.description || item.name }}</span>
              </v-chip>
            </template>
          </v-select>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" flat @click.stop="editItemData(roleId)">Save</v-btn>
        <v-btn color="primary" flat @click.stop="dialogClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import dialogMixins from '@/mixins/EditResourceDialog'
  import permissionsAPI from '@/api/resources/permissions'
  import rolesAPI from '@/api/resources/roles'
  import _ from 'lodash'

  export default {
    props: {
      roleId: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        resource: 'roles',
        permissionsList: [],
        selectedPermissions: [],
        dialogPermissions: false
      }
    },
    mixins: [ dialogMixins ],
    watch: {
      dialogResult (val) {
        if (this.roleId > 0 && val) {
          this.dialogPermissions = true
        }

        if (!val) {
          this.dialogPermissions = false
        }
      },
      roleId (newVal) {
        this.changedItemIdAction(newVal)

        this.selectedPermissions = []

        if (newVal > 0) {
          rolesAPI.loadRolePermissions(newVal).then(result => {
            result.forEach((item, i) => {
              this.permissionsList.forEach((permission, index) => {
                if (permission.id === item.id) {
                  this.selectedPermissions.push(permission.id)
                }
              })
            })

            this.permissionsList.sort((current, next) => current.text > next.text)
          }, () => {})
        }
      },
      selectedPermissions () {
        this.itemData.permissions = this.selectedPermissions
      }
    },
    methods: {
      setEditItemIdPermissionsZero () {
        this.$store.dispatch('setEditItemIdPermissions', 0)
      }
    },
    created () {
      permissionsAPI.loadPermissions().then(result => {
        this.permissionsList = _.filter(result, (p) => {
          p.text = p.description || p.text
          return p.description != null
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// AppEditRolesPermissionsDialog.vue?7f64c6ba